import axios from "../../../configs/axios";

export interface BrandGuideItem {
  id: string;
  title: string;
  description: string;
  category: string;
  iconType: string;
  iconColor: string;
  fileKey?: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface BrandGuideResponse {
  code: number;
  message: string;
  data: BrandGuideItem[];
}

export const brandGuideAPI = {
  // Get all active brand guide items
  getAllItems: async (): Promise<BrandGuideItem[]> => {
    const response = await axios.get<BrandGuideResponse>("/brand-guide");
    return response.data.data;
  },

  // Get brand guide items by category
  getItemsByCategory: async (category: string): Promise<BrandGuideItem[]> => {
    const response = await axios.get<BrandGuideResponse>("/brand-guide", {
      params: { category },
    });
    return response.data.data;
  },

  // Get single brand guide item by ID
  getItemById: async (id: string): Promise<BrandGuideItem> => {
    const response = await axios.get<{
      code: number;
      message: string;
      data: BrandGuideItem;
    }>(`/brand-guide/${id}`);
    return response.data.data;
  },

  // Get download URL and open it
  downloadFile: async (id: string) => {
    try {
      const response = await axios.get<{
        code: number;
        message: string;
        data: { downloadUrl: string };
      }>(`/brand-guide/${id}/download`);
      window.open(response.data.data.downloadUrl, "_blank");
    } catch (error) {
      console.error("Failed to get download URL:", error);
      throw new Error("Failed to download file");
    }
  },

  // Get preview URL for images
  getPreviewUrl: async (id: string): Promise<string> => {
    try {
      const response = await axios.get<{
        code: number;
        message: string;
        data: { downloadUrl: string };
      }>(`/brand-guide/${id}/download`);
      return response.data.data.downloadUrl;
    } catch (error) {
      console.error("Failed to get preview URL:", error);
      throw new Error("Failed to get preview URL");
    }
  },
};

// Category constants that match the backend
export const BRAND_GUIDE_CATEGORIES = {
  LOGOS_BRAND_MARKS: "Logos & Brand Marks",
  USAGE_GUIDELINES: "Usage Guidelines",
  TEMPLATES_ASSETS: "Templates & Assets",
} as const;

export type BrandGuideCategory =
  (typeof BRAND_GUIDE_CATEGORIES)[keyof typeof BRAND_GUIDE_CATEGORIES];
